import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import * as React from "react";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Tooltip } from "@mui/material";


const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

export default function DeletedUserDashboardModal({ deleteUserDashboardStates, dashboardName, deleteUserDashboard, deleteDashboard, showDeleteBtn, toBeDeletedItem }: any) {
    const [open, setOpen] = React.useState<boolean>(deleteDashboard);

    React.useEffect(() => {
        setOpen(deleteDashboard);
    }, [deleteDashboard]);

    const handleClose = () => setOpen(false);
    const handleOpen = () => {
        if (deleteUserDashboardStates != null) {
            deleteUserDashboardStates()
        }

        setOpen(true)
    };

    // const cancelLoanRequestBySupplierMutation = useMutation(
    //     cancelLoanRequestBySupplier,
    //     {
    //         onSuccess: (data: boolean) => {
    //             if (data) {
    //                 history.push("/loan/loan-list");
    //             }
    //         },
    //     }
    // );

    const handelDeleted = () => {


        toBeDeletedItem != undefined ? deleteUserDashboard(toBeDeletedItem) : deleteUserDashboard();
        handleClose();
    };

    const handelCancel = () => {
        handleClose();
    };

    return (
        <div>
            {showDeleteBtn == true ?
                <Tooltip title="حذف">
                    <Button id="deleteBtn" className={deleteDashboard ? "dashboardCRUDButton selected-dashboardCRUDPart-button" : "dashboardCRUDButton unselected-dashboardCRUDPart-button"} onClick={handleOpen}>
                        <DeleteOutlineIcon className={deleteDashboard ? "dashboardCRUDIcon selected-dashboardCRUDPart_Icon" : "dashboardCRUDIcon unselected-dashboardCRUDPart_Icon"} />
                    </Button>
                </Tooltip>
                : <></>}


            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
            >

                <Box
                    sx={style}
                    style={{
                        borderRadius: "5px",
                        padding: "40px 70px 70px 60px",
                        width: "100%",
                        maxWidth: "435px",
                        maxHeight: "252px"
                    }}
                    className=" textCenter "
                >
                    <div style={{ paddingTop: "20px" }}>
                        <b
                            className="textCenter mTop20 mbottom20"
                            style={{ color: "#757575", fontSize: "14px" }}
                        >
                            آیا از حذف داشبورد
                            <b className="colorCancel">
                                &nbsp;"{dashboardName}"&nbsp;
                            </b>{" "}
                            اطمینان دارید؟
                        </b>
                    </div>
                    <Grid
                        container
                        xs={12}
                        spacing={1}
                        style={{ paddingLeft: "2vh", paddingTop: "5vh", marginTop: "-30px" }}
                    >
                        <Grid item xs={2}></Grid>
                        <Grid item xs={4} style={{ paddingTop: "5vh" }}>
                            <Button
                                type="submit"
                                onClick={handelDeleted}
                                className="btnForm"
                                // , maxWidth: "122.5px"
                                style={{ backgroundColor: "#E6123D", width: "100%" }}
                            >
                                بله
                            </Button>
                        </Grid>
                        <Grid item xs={4} style={{ paddingTop: "5vh" }}>
                            <Button
                                onClick={handelCancel}
                                className="btnForm  ComingBack"
                                style={{ width: "100%" }}
                            >
                                خیر
                            </Button>
                        </Grid>
                        <Grid item xs={2}></Grid>
                    </Grid>
                </Box>

            </Modal>
        </div>
    );
}
